import { WebsiteCreateInterface, WebsiteErrorsInterface } from '../types/website-interface'

export const websiteDefaultErrors: WebsiteErrorsInterface = {
  name: '',
  homePagePath: '',
  domainId: '',
  locale: '',
  path: '',
  common: '',
}

export const websiteDefaultCreateValues: WebsiteCreateInterface = {
  name: '',
  homePagePath: '',
  domainId: null,
  locale: undefined,
}
